import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@masar/env/environment';
import { miscFunctions, Result } from 'mnm-webapp';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AiService {
    public constructor(private readonly httpClient: HttpClient) {}

    public enhanceText(
        text: string,
        instructions: string | undefined
    ): Observable<string> {
        return this.httpClient
            .post<Result<string>>(
                `${environment.apiUrl}/ai/enhance-text`,
                miscFunctions.objectToURLParams({
                    data: JSON.stringify({
                        text,
                        instructions,
                    }),
                })
            )
            .pipe(map(result => result.extra));
    }
}
